import { createElement, type HTMLAttributes, type ReactNode } from "react";
import "./surface.css";

type SurfaceProps = HTMLAttributes<HTMLElement> & {
  as?: "article" | "div" | "section" | "ul" | "figure";
  /** card: flat #fdfefe (feature grid) · screen: the North OS screen gradient, content clipped. */
  variant?: "card" | "screen";
  children: ReactNode;
};

/** The light card: 1 px border, 16 px radius, soft shadow above. */
export default function Surface({ as = "div", variant = "card", className, children, ...rest }: SurfaceProps) {
  return createElement(
    as,
    { ...rest, className: `ds-surface ds-surface--${variant}${className ? ` ${className}` : ""}` },
    children,
  );
}
